<script>
    export let style = ''
    export let align = 'flex-start'
    export let justify = 'center'
</script>

<div style={`align-items: ${align}; justify-content: ${justify}; ${style}`}>
    <slot />
</div>

<style>
    div {
        width: 100%;
        position: relative;
        display: flex;
        height: auto;
        gap: 12px;
        flex-direction: column;
    }
    @media only screen and (max-width: 600px) {
        div {
            flex-direction: column;
        }
    }
</style>
